import {
  DailyDistributionsRowConfigType,
  DailyDistributionItemType,
} from 'features/SCMS/@types/dpTypes'
import {
  DAY_NAMES,
  FORECAST_GAP_COLOR_THEME,
  MONTH_NAMES,
} from 'features/SCMS/constants/demandPlanning'

export const formatNumber = (v: number) => v.toLocaleString('id-ID')

export const formatGap = (v: number) => {
  if (v === 0) return '0'
  const formatted = Math.abs(v).toLocaleString('id-ID')
  return v > 0 ? `+${formatted}` : `-${formatted}`
}

export const formatPercent = (v: number) => {
  const trunkValue = Math.trunc(v * 100) / 100
  return trunkValue === 0 ? '0' : `${trunkValue}%`
}

export const formatDateHeader = (dateStr: string) => {
  const date = new Date(dateStr)
  const day = DAY_NAMES[date.getDay()]
  const dd = String(date.getDate()).padStart(2, '0')
  return { day, dd }
}

export const getMonthKey = (dateStr: string) => dateStr.slice(0, 7)

export const getMonthLabel = (monthKey: string) => {
  const [year, month] = monthKey.split('-')
  return `${MONTH_NAMES[parseInt(month, 10) - 1]} ${year}`
}

export const getMonthKeysInRange = (startDate: string, endDate: string) => {
  if (!startDate || !endDate || startDate > endDate) return []

  const [startYear, startMonth] = startDate.split('-').map(Number)
  const [endYear, endMonth] = endDate.split('-').map(Number)
  const monthKeys: string[] = []
  let year = startYear
  let month = startMonth

  while (year < endYear || (year === endYear && month <= endMonth)) {
    monthKeys.push(`${year}-${String(month).padStart(2, '0')}`)
    month += 1
    if (month > 12) {
      month = 1
      year += 1
    }
  }

  return monthKeys
}

export const getClippedMonthRange = (monthKey: string, startDate: string, endDate: string) => {
  const [year, month] = monthKey.split('-').map(Number)
  const lastDay = new Date(year, month, 0).getDate()
  const monthStart = `${monthKey}-01`
  const monthEnd = `${monthKey}-${String(lastDay).padStart(2, '0')}`

  return {
    startDate: monthStart < startDate ? startDate : monthStart,
    endDate: monthEnd > endDate ? endDate : monthEnd,
  }
}

export const getCellValue = (
  row: DailyDistributionsRowConfigType,
  item: DailyDistributionItemType,
): string => {
  if (row.isHeader) return ''
  if (row.computed) {
    const val = row.computed(item)
    return row.formatter ? row.formatter(val) : formatNumber(val)
  }
  if (row.key) {
    const val = item[row.key] as number
    return row.formatter ? row.formatter(val) : formatNumber(val)
  }
  return ''
}

export const getGapColorStyle = (gapPercentage: number) => {
  if (gapPercentage > 10) return FORECAST_GAP_COLOR_THEME.overforecast
  if (gapPercentage < -10) return FORECAST_GAP_COLOR_THEME.underforecast
  return FORECAST_GAP_COLOR_THEME.ok
}
